import React, { useState, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import { rescueHtml, addSpace } from '../components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page6IncidencesFinancieres_Operations_Part1 = (props) => {
    const blue = '#069BD3';
    const green = '#59B44A';
    const red = '#E74C3C';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);
    
    const [operation, setOperation] = useState(props.operation);
    const [modalites, setModalites] = useState([]);

    useEffect(() => {
        if (props.operation && props.operation.id) {
            setOperation(props.operation);
            loadIncidencesFinancieres(props.operation.id);
            loadModalites();
        }
    }, [props.operation?.id]);

    // Mettre à jour automatiquement le taux frais quand la modalité de portage change
    useEffect(() => {
        if (operation && operation.id_modalite_portage && modalites.length > 0) {
            
            const selectedModalite = modalites.find(m => String(m.id) === String(operation.id_modalite_portage));
            
            if (selectedModalite) {
                setOperation(prevOp => ({...prevOp, taux_frais_gestion: selectedModalite.taux}));
            }
        }
    }, [operation?.id_modalite_portage, modalites]);

    async function loadModalites() {
        try {
            const response = await axios.post('/api/modalites_portage.php', qs.stringify({
                get: true
            }));
            
            if (response && response.data) {
                const list = Array.isArray(response.data) ? response.data : (response.data.data ? response.data.data : []);
                setModalites(list || []);
            }
        } catch (err) {
            console.warn('Erreur lors du chargement des modalités:', err);
            setModalites([]);
        }
    }

    async function loadIncidencesFinancieres(operationId) {
        try {
            const response = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_by_operation',
                id_operation: operationId
            }));
            
            if (response && response.data && response.data.status === 1 && response.data.data) {
                const incidencesData = response.data.data;
                
                setOperation(prevOp => {
                    if (!prevOp) return prevOp;
                    
                    const updated = {...prevOp};
                    
                    let maxYearIdx = -1;
                    
                    // Merger les données de la BDD dans l'objet operation
                    incidencesData.forEach(row => {
                        const yearIdx = parseInt(row.year_index) || 0;
                        maxYearIdx = Math.max(maxYearIdx, yearIdx);
                        
                        // Mapper tous les champs incidences_*
                        updated[`incidences_prix_acquisition_${yearIdx}`] = row.incidences_prix_acquisition || '';
                        updated[`incidences_frais_actes_${yearIdx}`] = row.incidences_frais_actes || '';
                        updated[`incidences_subventions_${yearIdx}`] = row.incidences_subventions || '';
                        updated[`incidences_montant_retrocessions_${yearIdx}`] = row.incidences_montant_retrocessions || '';
                        updated[`incidences_frais_prealables_${yearIdx}`] = row.incidences_frais_prealables || '';
                        updated[`incidences_frais_annexes_${yearIdx}`] = row.incidences_frais_annexes || '';
                        updated[`incidences_frais_gegr_${yearIdx}`] = row.incidences_frais_gegr || '';
                        updated[`incidences_frais_proto_amenagement_${yearIdx}`] = row.incidences_frais_proto_amenagement || '';
                        updated[`incidences_ajustement_annuites_${yearIdx}`] = row.incidences_ajustement_annuites || '';
                        updated[`incidences_entretien_reparations_${yearIdx}`] = row.incidences_entretien_reparations || '';
                        updated[`incidences_eau_electricite_${yearIdx}`] = row.incidences_eau_electricite || '';
                        updated[`incidences_charges_copropriete_${yearIdx}`] = row.incidences_charges_copropriete || '';
                        updated[`incidences_taxes_foncieres_${yearIdx}`] = row.incidences_taxes_foncieres || '';
                        updated[`incidences_taxe_redevance_om_${yearIdx}`] = row.incidences_taxe_redevance_om || '';
                        updated[`incidences_assurances_${yearIdx}`] = row.incidences_assurances || '';
                        updated[`incidences_autres_depenses_${yearIdx}`] = row.incidences_autres_depenses || '';
                        updated[`incidences_loyers_percus_${yearIdx}`] = row.incidences_loyers_percus || '';
                        updated[`incidences_refacturation_eau_electricite_${yearIdx}`] = row.incidences_refacturation_eau_electricite || '';
                        updated[`incidences_refacturation_charges_copropriete_${yearIdx}`] = row.incidences_refacturation_charges_copropriete || '';
                        updated[`incidences_refacturation_taxes_foncieres_${yearIdx}`] = row.incidences_refacturation_taxes_foncieres || '';
                        updated[`incidences_refacturation_om_${yearIdx}`] = row.incidences_refacturation_om || '';
                        updated[`incidences_refacturation_assurances_${yearIdx}`] = row.incidences_refacturation_assurances || '';
                        updated[`incidences_autres_recettes_${yearIdx}`] = row.incidences_autres_recettes || '';
                        updated[`incidences_total_annuel_capital_porte_${yearIdx}`] = row.incidences_total_annuel_capital_porte || '';
                        updated[`incidences_total_annuel_hors_capital_porte_${yearIdx}`] = row.incidences_total_annuel_hors_capital_porte || '';
                        updated[`incidences_annuites_capital_porte_${yearIdx}`] = row.incidences_annuites_capital_porte || '';
                        updated[`incidences_annuite_hors_capital_porte_${yearIdx}`] = row.incidences_annuite_hors_capital_porte || '';
                        updated[`incidences_annuite_definitive_${yearIdx}`] = row.incidences_annuite_definitive || '';
                        updated[`incidences_capital_stocke_${yearIdx}`] = row.incidences_capital_stocke || '';
                        updated[`incidences_calcul_frais_portage_${yearIdx}`] = row.incidences_calcul_frais_portage || '';
                        updated[`incidences_frais_portage_ht_${yearIdx}`] = row.incidences_frais_portage_ht || '';
                        updated[`incidences_tva_frais_portage_${yearIdx}`] = row.incidences_tva_frais_portage || '';
                        updated[`incidences_frais_portage_ttc_${yearIdx}`] = row.incidences_frais_portage_ttc || '';
                        updated[`incidences_total_depenses_${yearIdx}`] = row.incidences_total_depenses || '';
                        updated[`incidences_total_recettes_${yearIdx}`] = row.incidences_total_recettes || '';
                        updated[`incidences_solde_annuel_frais_gestion_${yearIdx}`] = row.incidences_solde_annuel_frais_gestion || '';
                        updated[`incidences_solde_cumule_frais_gestion_${yearIdx}`] = row.incidences_solde_cumule_frais_gestion || '';
                        updated[`incidences_solde_operation_${yearIdx}`] = row.incidences_solde_operation || '';
                    });
                    
                    // Récupérer le solde d'opération de la dernière année
                    if (maxYearIdx >= 0) {
                        updated.solde_operation = updated[`incidences_solde_operation_${maxYearIdx}`] || '';
                    }
                    
                    return updated;
                });
            }
        } catch (err) {
            console.warn('Erreur lors du chargement des incidences financières:', err);
        }
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '10%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Incidences Financières - Partie 1</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{operation?.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '0 15px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                
                {/* Récapitulatif des données - Style OperationPage */}
                <div style={{display: 'flex', gap: 12, marginBottom: 12, padding: '8px 0', borderBottom: `1px solid ${greyclair}`, flexWrap: 'wrap'}}>
                    <div style={{flex: 1}}></div>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Année de 1ère acquisition</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.date_premiere_acquisition ? new Date(operation.date_premiere_acquisition).getFullYear() : '-'}
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Année de 1ère facturation</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.date_premiere_facturation ? new Date(operation.date_premiere_facturation).getFullYear() : '-'}
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Durée portage</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.duree_portage || '-'} ans
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Durée différé</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.duree_differe || '-'} ans
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Taux frais</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.taux_frais_gestion || '-'}%
                        </p>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center'}}>
                        <p style={{margin: 0, fontSize: fontsize, color: '#999'}}>Solde d'opération</p>
                        <p style={{margin: 0, fontSize: fontsize+3, fontWeight: 'bold', color: blue}}>
                            {operation?.solde_operation 
                                ? parseFloat(operation.solde_operation).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
                                : '-'
                            }
                        </p>
                    </div>
                    <div style={{flex: 1}}></div>
                </div>

                {/* Tableau complet - comme dans OperationPage */}
                {operation && operation.duree_portage && parseInt(operation.duree_portage) > 0 ? (
                    <div style={{width: '100%', overflowX: 'auto', overflowY: 'auto', flex: 1, borderRadius: '6px', border: `1px solid ${greyclair}`, marginTop: '8px', position: 'relative', minWidth: 0}}>
                        <div style={{display: 'flex', minWidth: 'min-content'}}>
                            {/* Colonne Catégorie */}
                            <div style={{width: 40, minWidth: 40, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', height: 18, alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', fontWeight: 'bold', minHeight: 18, position: 'sticky', left: 0, top: 0, zIndex: 12}}></div>
                                
                                {/* Dépenses amortissables */}
                                <div style={{height: 240, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>Dépenses amortissables</div>
                                </div>
                                
                                {/* Lignes intermédiaires */}
                                {Array(1).fill(null).map((_, i) => (<div key={i + 10} style={{height: 12, backgroundColor: 'transparent'}}></div>))}
                                
                            </div>

                            {/* Colonne Figée - Libellés */}
                            <div style={{minWidth: 200, maxWidth: 300, backgroundColor: 'transparent', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', height: 18, alignItems: 'center', padding: '0 10px', backgroundColor: blue, fontWeight: 'bold', minHeight: 18, position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                    <p style={{marginTop: (0-props.marge), color: 'white', margin: 0, fontSize: fontsize-1}}>Libellé (en euro)</p>
                                </div>

                                {/* Lignes */}
                                {[
                                    { label: 'Prix d\'acquisition (A)', key: 'incidences_prix_acquisition' },
                                    { label: 'Frais d\'actes (F)', key: 'incidences_frais_actes' },
                                    { label: 'Subventions (SUB)', key: 'incidences_subventions' },
                                    { label: 'Montant rétrocessions (RETRO)', key: 'incidences_montant_retrocessions' },
                                    { label: 'Total annuel - capital porté (ST1)', key: 'incidences_total_annuel_capital_porte', isBold: true, isCalculated: true },
                                    { label: 'Frais préalables (FP)', key: 'incidences_frais_prealables' },
                                    { label: 'Frais annexes (FA)', key: 'incidences_frais_annexes' },
                                    { label: 'Frais GEGR (GEGR)', key: 'incidences_frais_gegr' },
                                    { label: 'Frais proto-aménagement (PROTO)', key: 'incidences_frais_proto_amenagement' },
                                    { label: 'Total annuel - hors capital porté (ST2)', key: 'incidences_total_annuel_hors_capital_porte', isBold: true, isCalculated: true },
                                    { label: '', isEmpty: true },
                                    { label: 'Annuités sur le capital porté (AKP)', key: 'incidences_annuites_capital_porte', isCalculated: true },
                                    { label: 'Ajustement éventuels des annuités (AJ)', key: 'incidences_ajustement_annuites' },
                                    { label: 'Annuité hors capital porté (AHKP)', key: 'incidences_annuite_hors_capital_porte', isCalculated: true },
                                    { label: 'Annuité définitive à facturer (AT)', key: 'incidences_annuite_definitive', isBold: true, isCalculated: true },
                                    { label: '', isEmpty: true },
                                    { label: 'TOTAL - capital stocké au 31/12 (KS)', key: 'incidences_capital_stocke', isBold: true, isCalculated: true },
                                    { label: '', isEmpty: true },
                                    { label: 'Total capital porté au 31/12 (CFP)', key: 'incidences_calcul_frais_portage', isCalculated: true },
                                    { label: 'Frais de portage HT (FPHT)', key: 'incidences_frais_portage_ht', isCalculated: true },
                                    { label: 'TVA sur frais de portage 20% (TVA)', key: 'incidences_tva_frais_portage', isCalculated: true },
                                    { label: 'Frais de portage TTC (FPTTC)', key: 'incidences_frais_portage_ttc', isBold: true, isCalculated: true }
                                ].map((row, idx) => (
                                    <div key={idx} style={{display: 'flex', height: row.isEmpty ? 12 : 24, alignItems: 'center', padding: '0 8px', borderBottom: row.isEmpty ? 'none' : '1px solid #ddd', backgroundColor: row.isCalculated ? '#f0f0f0' : '#ffffff', minHeight: row.isEmpty ? 12 : 24, position: 'sticky', left: 0, zIndex: 11}}>
                                        <p style={{marginTop: (0-props.marge), fontSize: fontsize-2, fontWeight: row.isBold ? 'bold' : 'normal'}}>{row.label}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Colonnes de données */}
                            <div style={{display: 'flex', flex: 1}}>
                                {(() => {
                                    const currentYear = new Date().getFullYear();
                                    let endYear = currentYear;
                                    
                                    if (operation?.date_premiere_acquisition && operation?.duree_portage) {
                                        const yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
                                        endYear = yearAcquisition + parseInt(operation.duree_portage);
                                    }
                                    
                                    const totalColumnsAll = Math.max(0, endYear - currentYear + 1);
                                    const totalColumns = Math.min(9, totalColumnsAll); // Maximum 9 colonnes
                                    
                                    return Array.from({length: totalColumns}).map((_, yearIdx) => (
                                        <div key={yearIdx} style={{minWidth: 90, display: 'flex', flexDirection: 'column', flexShrink: 0}}>
                                            {/* Header année */}
                                            <div style={{display: 'flex', height: 18, alignItems: 'center', justifyContent: 'center', padding: '0 3px', backgroundColor: blue, fontWeight: 'bold', minHeight: 18, borderBottom: '1px solid #ddd', position: 'sticky', top: 0, zIndex: 10}}>
                                                <p style={{marginTop: (0-props.marge), color: 'white', fontSize: fontsize-2}}>
                                                    {currentYear + yearIdx}
                                                </p>
                                            </div>

                                            {/* Données */}
                                            {[
                                                { key: 'incidences_prix_acquisition', isCalculated: false },
                                                { key: 'incidences_frais_actes', isCalculated: false },
                                                { key: 'incidences_subventions', isCalculated: false },
                                                { key: 'incidences_montant_retrocessions', isCalculated: false },
                                                { key: 'incidences_total_annuel_capital_porte', isBold: true, isCalculated: true },
                                                { key: 'incidences_frais_prealables', isCalculated: false },
                                                { key: 'incidences_frais_annexes', isCalculated: false },
                                                { key: 'incidences_frais_gegr', isCalculated: false },
                                                { key: 'incidences_frais_proto_amenagement', isCalculated: false },
                                                { key: 'incidences_total_annuel_hors_capital_porte', isBold: true, isCalculated: true },
                                                { isEmpty: true },
                                                { key: 'incidences_annuites_capital_porte', isCalculated: true },
                                                { key: 'incidences_ajustement_annuites', isCalculated: false },
                                                { key: 'incidences_annuite_hors_capital_porte', isCalculated: true },
                                                { key: 'incidences_annuite_definitive', isBold: true, isCalculated: true },
                                                { isEmpty: true },
                                                { key: 'incidences_capital_stocke', isBold: true, isCalculated: true },
                                                { isEmpty: true },
                                                { key: 'incidences_calcul_frais_portage', isCalculated: true },
                                                { key: 'incidences_frais_portage_ht', isCalculated: true },
                                                { key: 'incidences_tva_frais_portage', isCalculated: true },
                                                { key: 'incidences_frais_portage_ttc', isBold: true, isCalculated: true }
                                            ].map((row, idx) => {
                                                const columnYear = currentYear + yearIdx;
                                                let yearIdxForData = 0;
                                                
                                                if (operation?.date_premiere_acquisition) {
                                                    const yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
                                                    yearIdxForData = columnYear - yearAcquisition;
                                                }
                                                
                                                const fieldName = row.key ? `${row.key}_${yearIdxForData}` : null;
                                                const displayValue = fieldName ? operation?.[fieldName] : null;
                                                
                                                const formatNumber = (num) => {
                                                    if (!num || isNaN(num)) return '';
                                                    const parsed = parseFloat(num);
                                                    return parsed.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                };
                                                
                                                return (
                                                    <div key={idx} style={{display: 'flex', height: row.isEmpty ? 12 : 24, borderBottom: row.isEmpty ? 'none' : '1px solid #ccc', alignItems: 'center', justifyContent: 'center', minHeight: row.isEmpty ? 12 : 24, backgroundColor: row.isEmpty ? 'transparent' : '#ffffff'}}>
                                                        {row.isEmpty ? (
                                                            <div></div>
                                                        ) : row.isCalculated ? (
                                                            <div style={{width: '100%', height: '100%', fontSize: fontsize-3, textAlign: 'center', fontWeight: row.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0', borderLeft: '1px solid #ddd', color: row.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                                {displayValue && !isNaN(displayValue) && parseFloat(displayValue) !== 0 ? formatNumber(displayValue) : ''}
                                                            </div>
                                                        ) : (
                                                            <div style={{width: '100%', height: '100%', fontSize: fontsize-3, textAlign: 'center', fontWeight: row.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderLeft: '1px solid #ddd', padding: '0 2px'}}>
                                                                {displayValue ? formatNumber(displayValue) : ''}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{
                        backgroundColor: greyclair,
                        padding: '20px',
                        borderRadius: '6px',
                        textAlign: 'center',
                        border: `1px solid ${blue}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1
                    }}>
                        <p style={{fontSize: fontsize-1, color: greyChapter, margin: 0}}>
                            Aucune incidence enregistrée
                        </p>
                    </div>
                )}
            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page6IncidencesFinancieres_Operations_Part1;
